<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

<div [hidden]="skelition" class="row mx-5">
  <div class="col-md-8 col-12 p-0">
    <app-no-data *ngIf="data.length <= 0 && !skelition"></app-no-data>
    <div *ngIf="data.length > 0" class="container mb-4">
      <app-table [data]="data" (actionCall)="actionCall($event)"></app-table>
    </div>
  </div>



  <div class="col-md-4 col-12 p-0">
    <div class="container mb-5">
      <h2 class="text-center text-black"><i style="font-size: 2rem;"
          class="pi pi-fw pi-plus-circle mx-2 text-black"></i>{{"Add a new role"| translator}}</h2>
      <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>
<!-- Confirm Modal -->
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false"header="Header" [(visible)]="updateModal" [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">Update Modal </span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<app-footer></app-footer>